import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing webix photo module
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix

/**
 * Class representing the user management filter view.
 * @extends JetView
 */
export default class FilterUserManagementView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const screen = this.app.config.size; // Getting the screen size configuration

        // Configuration for the user ID input field
        const fecha = {
            margin: 5,
            minWidth: 100,
            rows: [
                {
                    view: 'text', // Text input for user ID
                    name: 'PlayerId', // Name of the input field
                    label: "<span class='icon-drivers-license-o'></span>" + _('ID Usuario'), // Label with icon
                    hidden: !devConfig.getPermAction('filterByUser', 'Add'), // Conditional visibility based on permissions
                    css: 'prm-filterByUser', // CSS class for styling
                    labelPosition: 'top', // Position of the label
                    placeholder: _('ID Usuario'), // Placeholder text
                    invalidMessage: _('ID Usuario is required'), // Message shown when input is invalid
                },
            ],
        };

        const playerId = {
            // Placeholder for player ID section
            margin: 5,
            rows: [],
        };

        const transactionId = {
            // Placeholder for transaction ID section
            margin: 5,
            rows: [],
        };

        // Upper section layout containing input fields
        const upper_section = {
            id: 'a1',
            rows: [
                {
                    responsive: 'a1', // Responsive layout identifier
                    margin: 10,
                    cols: [fecha, playerId, transactionId], // Columns for input fields
                },
            ],
        };

        // Button layout for actions
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button', // Clear button
                    value: _('Limpiar'), // Button label
                    autowidth: true, // Automatic width adjustment
                    click: () => {
                        // Click event handler
                        this.getRoot().clear(); // Clears the form inputs
                    },
                },
                {
                    view: 'button', // Consult button
                    value: _('Consultar'), // Button label
                    type: 'form', // Button type indicating form submission
                    autowidth: true, // Automatic width adjustment
                    click: () => {
                        // Click event handler
                        const filterdata = this.getRoot().getValues(); // Get form values
                        this.app.callEvent('userManagement:filter', [filterdata]); // Trigger filter event with data
                    },
                },
            ],
        };

        // Return the complete form configuration
        return {
            view: 'form', // Main view type
            rows: [upper_section, buttons], // Rows containing upper section and buttons
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }
}

// FILE DOCUMENTED
